fragment ContentBlockVideo on contentBlocks_video_BlockType {
    title: sectionTitle
    videoUrl
    frameTitle
    caption

    anchorId
    anchorLabel
}
